/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserModerationsModeratorControllerPatchMutationRequest,
  UserModerationsModeratorControllerPatchMutationResponse,
  UserModerationsModeratorControllerPatchPathParams,
  UserModerationsModeratorControllerPatch401,
  UserModerationsModeratorControllerPatch404,
} from '../types/UserModerationsModeratorControllerPatch.ts';

function getUserModerationsModeratorPatchUrl(id: UserModerationsModeratorControllerPatchPathParams['id']) {
  const res = { method: 'PATCH', url: `/api/moderator/user-moderations/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/user-moderations/:id}
 */
export async function userModerationsModeratorPatch(
  id: UserModerationsModeratorControllerPatchPathParams['id'],
  data?: UserModerationsModeratorControllerPatchMutationRequest,
  config: Partial<RequestConfig<UserModerationsModeratorControllerPatchMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UserModerationsModeratorControllerPatchMutationResponse,
    ResponseErrorConfig<UserModerationsModeratorControllerPatch401 | UserModerationsModeratorControllerPatch404>,
    UserModerationsModeratorControllerPatchMutationRequest
  >({
    method: 'PATCH',
    url: getUserModerationsModeratorPatchUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
